export default class Breadcrumbs {
    mount({ breadcrumbsSelector, sidebarSelector, mainSelector }) {
        $(breadcrumbsSelector).click(() => {
            $(sidebarSelector).show();
            $(mainSelector).hide();
        });
    }
}



// WEBPACK FOOTER //
// ./themes/docs/static/js/breadcrumbs.js